import { UserProvider } from '@libs/contexts';
import { DeleteDialogProvider, GuideTabProvider } from '@ps-smart-cp/ppfw-client';
import { Outlet } from 'react-router';

function AppContainer() {
  return (
    <DeleteDialogProvider>
      <GuideTabProvider>
        <UserProvider>
          <Outlet />
        </UserProvider>
      </GuideTabProvider>
    </DeleteDialogProvider>
  );
}

export { AppContainer };
